import React from 'react';
import { CARD_SHAPES } from '../utils/constants';
import { getShapeEmoji } from '../utils/deck';
import WhotCard from './WhotCard';
import '../../styles/Whot.css';

const SHAPES = [CARD_SHAPES.CIRCLE, CARD_SHAPES.SQUARE, CARD_SHAPES.STAR, CARD_SHAPES.TRIANGLE, CARD_SHAPES.CROSS];

export default function WhotGameTable({
  topRow,
  topCard,
  deckRemaining,
  currentShape,
  turnLabel,
  turnTimeLeft,
  pickBannerText,
  onDrawCard,
  isCurrentPlayer,
  awaitingShapeCall,
  onCallShape,
  onRegisterDeckEl,
  onRegisterTopCardEl,
  children,
}) {
  return (
    <div className="whot-table">
      {(turnLabel || turnTimeLeft) && (
        <div className="whot-table-corner" aria-live="polite">
          <div className="whot-table-corner-title">Turn</div>
          <div className="whot-table-corner-value">{turnLabel || '—'}</div>
          {turnTimeLeft ? (
            <div className="whot-table-corner-timer">{turnTimeLeft}</div>
          ) : null}
        </div>
      )}
      {pickBannerText ? (
        <div className="whot-pick-banner whot-pick-banner--danger whot-table-left-banner" aria-live="polite">
          {pickBannerText}
        </div>
      ) : null}
      {topRow ? <div className="whot-table-toprow">{topRow}</div> : null}
      <div className="whot-table-center">
        <div style={{ textAlign: 'center' }}>
          <div className="whot-topcard-slot" ref={onRegisterTopCardEl}>
            <WhotCard card={topCard} isSmall={true} isPlayable={false} />
          </div>
          {currentShape && (
            <div className="whot-pill" style={{ marginTop: 10 }}>
              Shape: {getShapeEmoji(currentShape)}
            </div>
          )}
        </div>

        <div className="whot-turn-indicator" aria-live="polite">
          {isCurrentPlayer && !awaitingShapeCall ? 'Your turn' : 'Waiting…'}
        </div>

        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              opacity: isCurrentPlayer ? 1 : 0.6,
              cursor: isCurrentPlayer ? 'pointer' : 'not-allowed',
              display: 'inline-block',
              maxWidth: 48,
            }}
            role="button"
            tabIndex={0}
          >
            <div className="whot-deck-slot" ref={onRegisterDeckEl} style={{ maxWidth: 48 }}>
              <WhotCard
                isFaceDown
                badge={deckRemaining}
                isSmall={true}
                onClick={() => {
                  if (isCurrentPlayer && !awaitingShapeCall) onDrawCard?.();
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {children ? (
        <div className="whot-table-playzone">{children}</div>
      ) : null}

      {awaitingShapeCall && isCurrentPlayer && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.55)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: 'rgba(30,40,80,0.98)',
            borderRadius: 18,
            padding: 24,
            minWidth: 220,
            boxShadow: '0 8px 32px 0 rgba(0,0,0,0.25)',
            border: '1.5px solid rgba(255,255,255,0.13)',
            textAlign: 'center',
          }}>
            <div style={{ fontWeight: 900, fontSize: '1.15em', marginBottom: 12 }}>You played WHOT!<br/>Choose a shape:</div>
            <div className="whot-shape-options" style={{ justifyContent: 'center', gap: 12, display: 'flex', marginTop: 8 }}>
              {SHAPES.map((shape) => (
                <button
                  key={shape}
                  className="whot-shape-option"
                  onClick={() => onCallShape?.(shape)}
                  style={{ background: 'transparent', width: 72, height: 100, borderRadius: 12, border: 'none', outline: 'none', cursor: 'pointer', padding: 0 }}
                >
                  <WhotCard
                    card={{ id: `shape-choice-${shape}`, number: 3, shape }}
                    isSmall={true}
                    isPlayable={true}
                    hideNumber={true}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
